import { render, staticRenderFns } from "./IdNameValueSelectModal.vue?vue&type=template&id=6fb875f6"
import script from "./IdNameValueSelectModal.vue?vue&type=script&lang=js"
export * from "./IdNameValueSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports